import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useNavigate, useParams } from 'react-router-dom'

import { useRecoilValue } from 'recoil'

import { PageHeader } from 'mailup-web-components'

import setMenuItem from 'Helpers/setMenuItem'
import { pageState } from 'State/page'
import { recipientState } from '../recoil/state/result'

import { RECIPIENTS_LIST_LABEL } from 'Constants'

const Header = () => {
  const intl = useIntl()
  const navigate = useNavigate()
  const { idRecipient } = useParams()

  const { loading } = useRecoilValue(pageState)
  const { recipientProfile, channel } = useRecoilValue(recipientState)

  useEffect(() => {
    setMenuItem('ActiveRecipientsClickDetailsUnified')
  }, [])

  const breadcrumbsItems =
    channel === 'email'
      ? [
          {
            label: intl.formatMessage({ id: 'Load.NavMenu.Recipients' }),
            'data-mu-test': 'breadcrumb-item__recipients',
            onClick: Function.prototype,
          },
          {
            label: intl.formatMessage({
              id: RECIPIENTS_LIST_LABEL,
            }),
            'data-mu-test': 'breadcrumb-item__email',
            url: '#',
            onClick: () => {
              navigate(
                `/recipients/list?rid=${encodeURIComponent(idRecipient)}`,
              )
            },
          },
          {
            label: intl.formatMessage({
              id: 'Load.NavMenu.StatsActiveRecipientsClickDetails',
            }),
            'data-mu-test': 'breadcrumb-item__trend',
            onClick: Function.prototype,
          },
        ]
      : [
          {
            label: intl.formatMessage({ id: 'Load.NavMenu.Recipients' }),
            'data-mu-test': 'breadcrumb-item__recipients',
            onClick: Function.prototype,
          },
          {
            label: intl.formatMessage({
              id: RECIPIENTS_LIST_LABEL,
            }),
            'data-mu-test': 'breadcrumb-item__sms',
            url: '#',
            onClick: () => {
              navigate('/recipients/list')
            },
          },
          {
            label: intl.formatMessage({
              id: 'Load.NavMenu.StatsActiveRecipientsClickDetails',
            }),
            'data-mu-test': 'breadcrumb-item__trend',
            onClick: Function.prototype,
          },
        ]
  const menuItems = [
    {
      label: intl.formatMessage({
        id: 'Load.NavMenu.StatsActiveRecipientsTrend',
      }),
      'data-mu-test': 'topmenu-item__profile-summary__trend',
      onClick: () => navigate(`/recipients/profile/${idRecipient}/trend`),
    },
    {
      label: intl.formatMessage({
        id: 'Load.NavMenu.StatsActiveRecipientsClickDetails',
      }),
      'data-mu-test': 'topmenu-item__profile-summary__click-details',
      isActive: true,
    },
    {
      label: intl.formatMessage({
        id: 'Load.NavMenu.StatsActiveRecipientsBounces',
      }),
      onClick: () => navigate(`/recipients/profile/${idRecipient}/bounce`),
    },
  ]

  return (
    <PageHeader
      title={
        recipientProfile.Email
          ? recipientProfile.Email
          : recipientProfile.MobileNumber
      }
      breadcrumbsItems={breadcrumbsItems}
      menuItems={menuItems}
      loading={loading}
    />
  )
}

export default Header
